skrilla.controller('pickemsContestDetailsCtrl', async function ($scope, searchService, $stateParams, paginationService, queryService, $location, modalService, cacheService, srefService, dollarOrSkrillaFilter, envService, uiUrlsService) {
    function monetize(value) {
        return dollarOrSkrillaFilter(value, 'USD')
    }

    const getEntries = function () {
        return searchService.get('pickems/contests/entries/' + queryService.getQueryString($scope.query, $scope.pageKey)).then(function (response) {
            $scope.entries = response.data.result;
            $scope.entries.forEach((entry) => {
                entry.potentialPayout = monetize(entry.paidOut)
                if (entry.status === 'WON' || entry.status === "PLACED") {
                    entry.payout = monetize(entry.paidOut)
                } else {
                    entry.payout = monetize(0)
                }
            })
            paginationService.setPage($scope.pageKey, paginationService.buildPage(response));
        });
    };
    $scope.key = "contestDetails";
    $scope.pageKey = "entries";
    $scope.positionNames = ['1st', '2nd', '3rd', '4th', '5th'];
    $scope.tabs = [
        {title: "Contest Details", active: true},
        {title: "Entries", active: false}
    ];
    const userId = $location.search().userId || null;
    const defaultQuery = {
        limit: 20,
        contestId: $stateParams.id,
        userId: userId,
        statuses: {
            LIVE: true,
            WON: true,
            PLACED: true,
            LOST: true,
            CANCELLED: true
        }
    };
    $scope.query = defaultQuery

    $scope.uiUrl = await uiUrlsService.getPickemsContestUrl($stateParams.id)

    $scope.reset = function () {
        $scope.query = {
            ...defaultQuery, userId: null
        };
    };


    $scope.addMarkets = function () {
        cacheService.registerObject("selectedPickemsContests", [$scope.contest]);
        modalService.openModal('/views/pickems/contests/createContestMarketsModal.html', true, 'lg', false, false, function () {
            $scope.get();
        });
    }

    $scope.get = function () {
        searchService.get('pickems/contests/' + $stateParams.id).then(function (response) {
            $scope.contest = response.data;


            const outcomes = {};
            Object.entries($scope.contest.markets).forEach(([k, m]) => {
                Object.assign(outcomes, m.outcomes);
            })
            $scope.outcomes = outcomes;
            console.log("outcomes: ", outcomes);

            if ($scope.contest.cardImageUri && $scope.contest.cardImageUri.startsWith("https://res.cloudinary")) {
                $scope.thumbnail = $scope.contest.cardImageUri.replace("/upload", "/upload/c_scale,h_150")
            } else {
                $scope.thumbnail = $scope.contest.cardImageUri
            }

        });
    };
    $scope.get()

    $scope.publish = function () {
        searchService.post('pickems/contests/' + $stateParams.id + "/publish", {}, "Published Contest")
    };

    $scope.updateScores = function () {
        searchService.post('pickems/contests/' + $stateParams.id + "/entries/scores", {}, "Entry Scores Updated").then(function (response) {
            $scope.get()
        });
    };

    $scope.cancelMarket = function (market) {
        modalService.confirm("Are you sure you'd like to cancel this market?. All outcomes will be voided and will not contribute to scores in any active related contests.", function () {
            searchService.post('pickems/contests/' + $stateParams.id + "/markets/" + market.id + "/cancel", {}, "Cancelled Market").then(function (response) {
                $scope.get()
            });
        });
    };

    $scope.deleteMarket = function (market) {
        modalService.confirm("Are you sure you'd like to remove this market from the contest?", function () {
            searchService.deleteRequest('pickems/contests/' + $stateParams.id + "/markets/" + market.id,  "Removed market from contest", true).then(function (response) {
                $scope.get()
            });
        });
    };

    $scope.result = function () {
        modalService.confirm("Are you sure you'd like to result this contest?", function () {
            searchService.post('pickems/contests/' + $stateParams.id + "/result", {}, "Resulted Contest").then(function (response) {
                $scope.get()
            });
        });
    };
    $scope.cancel = function () {
        modalService.confirm("Are you sure you'd like to cancel this contest?", function () {
            searchService.post('pickems/contests/' + $stateParams.id + "/cancel", {}, "Cancelled Contest").then(function (response) {
                $scope.get()
            });
        });
    };

    $scope.rollback = function () {
        modalService.confirm("Are you sure you'd like to rollback this contest to a live state?", function () {
            searchService.post('pickems/contests/' + $stateParams.id + "/rollback", {}, "Rolled back Contest").then(function (response) {
                $scope.get()
            });
        });
    };

    $scope.searchEntries = function () {
        paginationService.resetPage($scope.pageKey);
        paginationService.pageQuery(getEntries, $scope.pageKey);
    };


    $scope.request = (outcome, contestId) => {
        //todo: remove this when we have a UI
        const request = {
            contestId: contestId,
            selections: [
                {
                    outcomeId: outcome.id,
                    points: outcome.points

                }
            ]
        };
        return JSON.stringify(request)
    };

    $scope.showEntry = function (entry) {
        cacheService.registerObject("entry", entry);
        cacheService.registerObject("contest", $scope.contest);
        modalService.openModal('/views/pickems/contestDetails/entryModal.html', true, 'lg', true, false);
    }
    $scope.notify = function () {
        cacheService.registerObject("contest", $scope.contest);
        modalService.openModal('/views/pickems/contestDetails/notifyModal.html', true, 'lg', true, false);
    }
    $scope.contests = function () {
        srefService.go("pickemsContests");
    }
    $scope.isHistorical = ()=> $scope.contest.status === "COMPLETED" || $scope.contest.status === "CANCELLED"
});

